import { formatPriceAmount } from "@/utils/format.js";
import "./price-display.css";

export default function Price({ value, unitPrice, quantity, className = "" }) {
    const numericValue = value ?? Number(unitPrice) * Number(quantity);
    const amount = formatPriceAmount(numericValue);
    const classNames = ["price-display", className].filter(Boolean).join(" ");

    return (
        <span className={classNames}>
            <span className="price-display__amount">{amount}</span>
            <span className="price-display__currency">{"\u00a0"}FCFA</span>
        </span>
    );
}
